import {useTheme} from 'styled-components';
import clsx from 'clsx';
import {StyledIcon, TextContainer, Wrapper} from './styled';

type QuestionMarkAndTextProps = {
  onClick: () => void;
  text?: string;
  iconSize?: number | string;
  className?: string;
};

function QuestionMarkAndText({
  onClick,
  text,
  iconSize = 16,
  className,
}: QuestionMarkAndTextProps) {
  const theme = useTheme();
  return (
    <Wrapper onClick={onClick} className={clsx('question-mark-text', className)}>
      <StyledIcon
        name="questionMarkIcon"
        size={iconSize}
        color={theme.colors.buttons.textButton}
      />
      <TextContainer>{text ?? ''}</TextContainer>
    </Wrapper>
  );
}

export {QuestionMarkAndText};
